import Image from "next/image"
import Link from "next/link"
import React, {useContext, useEffect, useState} from "react"
import WhatsAppButton from "./WhatsAppButton"
import NavBarCtas from "./desktop/NavBarCtas"
import LayoutContext from "../../context/LayoutContext"
import {List, XLg} from "react-bootstrap-icons"
import AnimationComponent from "../reusable/components/AnimationComponent/AnimationComponent"
import {MenuTitle} from "./NavBar"
import BrandWorldMegaMenu from "./BrandWorldMegaMenu"
import DataContext from "../../context/DataContext"
import {useRouter} from "next/router"
import {formatImageSrc} from "../../strapi/strapiHelpers"

type Props = {
	secondLineMenu: MenuTitle[];
};

export const onMegaMenuBtnClick = (router, pathname) => {
	if (!router) {
		console.error("Router is undefined")
		return
	}

	const params = new URLSearchParams()

	if (router?.query) {
		Object.entries(router.query).forEach(([key, value]) => {
			params.set(key, value as string)
		})
	}

	if (params.has("megamenu")) {
		params.delete("megamenu")
		router.replace(`${pathname}?${params}`, null, {shallow: true, scroll: false})
		return
	}

	params.append("megamenu", "open")
	router.push(`${pathname}?${params}`, null, {shallow: true, scroll: false})
}

function BrandWorldNavBar() {
	const {isMobile} = useContext(LayoutContext)
	const router = useRouter()
	const toggleMenu = e => {
		onMegaMenuBtnClick(router, router.pathname)
	}

	const isMenuVisible = router?.query?.megamenu === "open" || false

	const [isScrolled, setIsScrolled] = useState(false)

	useEffect(() => {
		const handleScroll = () => {
			const scrollThreshold = 100
			if (window.scrollY > scrollThreshold) {
				setIsScrolled(true)
			} else {
				setIsScrolled(false)
			}
		}

		window.addEventListener("scroll", handleScroll)

		return () => {
			window.removeEventListener("scroll", handleScroll)
		}
	}, [])

	const {brandWorld} = useContext(DataContext)
	return (
		<div
			style={{
				minHeight: "68px",
				position: "sticky",
				top: "0px",
				backgroundColor: "#212529",
				zIndex: "999"
			}}
			className="px-2 col-12 d-flex align-items-center justify-content-center"
		>
			<div
				style={{zIndex: "50"}}
				className="position-relative container d-flex gap-4 align-items-center justify-content-center justify-content-md-between">
				<img
					style={{
						position: "absolute",
						top: "-10px",
						left: "50%",
						transform: "translateX(-50%)",
						zIndex: "10",
						maxWidth: "100%",
						height: "auto"
					}}
					className={`${isScrolled ? "fade-out" : ""}`}
					src={formatImageSrc(brandWorld?.blurOnTop?.data?.attributes?.url)}
					width={689}
					height={384}
					alt="Top Blur"
				/>

				{/* Mobile Menu Toggle */}
				<div className="d-flex z-index-15 h-100 d-md-none align-items-center justify-content-start">
					<div className="d-flex align-items-center p-md-2 pe-0 cursor-pointer">
						{isMenuVisible ? (
							<XLg
								onClick={e => toggleMenu(e)}
								color={"#fff"}
								size={24}
							/>
						) : (
							<List
								style={{zIndex: "52"}}
								onClick={e => toggleMenu(e)}
								width={24}
								height={24}
								color={"#fff"}
							/>
						)}
					</div>
					<WhatsAppButton isBrandsPage
						onlyIcon
						classes={"d-block d-md-none"} />
				</div>

				{/* Logo */}
				<div
					className="d-flex z-index-15 align-items-center"
					style={{columnGap: 16, minHeight: 40}}
				>
					<Link href={"/"}
						as={"/"}
						passHref>
						<a className="d-inline-flex align-items-center">
							<Image
								className="pointer main-logo"
								width={isMobile ? 116 : 202}
								height={isMobile ? 16 : 28}
								layout="fixed"
								src="/assets/logo-light.svg"
								alt="MyBikePlan logo"
								style={{marginTop: 1}}
							/>
						</a>
					</Link>
				</div>

				{/* CTAs */}
				<div className="z-index-15 d-flex align-items-center justify-content-start gap-2">
					<NavBarCtas whatsappBtnBgColor={brandWorld?.buttonsBackgroundColor} />
				</div>
			</div>

			{/* Mega Menu */}
			<AnimationComponent type="slideRight"
				inProp={isMenuVisible}>
				<div
					className={"position-fixed vh-100 vw-100 overflow-auto"}
					style={{zIndex: 99999999, top: "67px"}}
					onClick={e => {
						toggleMenu(e)
					}}
				>
					<BrandWorldMegaMenu setIsMenuVisible={toggleMenu} />
				</div>
			</AnimationComponent>
		</div>
	)
}

export default BrandWorldNavBar
